<template>
    <div>
        <div>
            <span class="h5">
                #{{ oc_selecionada.id_aquisicao_ordem_compra }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ $util.getFormatDate(oc_selecionada.created_at) }}
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                {{ oc_selecionada.fornecedor.search }}
            </span>
        </div>
        <div class="small text-muted mt-2">
            Aquisição: #{{ oc_selecionada.id_aquisicao }} 
            <span v-if="oc_selecionada.usuario_emissor">
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                Emissor: {{ oc_selecionada.usuario_emissor.st_login }}
            </span>
            <span v-if="oc_selecionada.usuario_autorizador">
                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                Aut.: {{ oc_selecionada.usuario_autorizador.st_login }}
            </span>
        </div>
        <hr>
        <div class="row">
            <div class="col col-12 col-md-4">
                <button type="button" class="btn btn-primary" data-toggle="tooltip" title="Imprimir Ordem de Compra" @click="imprimir_oc()">
                    <i class="fa fa-print" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn btn-outline-danger ml-1" data-toggle="tooltip" title="Cancelar Ordem de Compra" @click="remover_oc()">
                    <i class="fas fa-trash-alt"></i>
                </button>
                <az-submit color="outline-secondary ml-1" data-toggle="tooltip" title="Enviar Ordem de Compra para Autorização" @click="enviar_oc_para_autorizacao()" v-if="oc_selecionada.fl_autorizado === null">
                    <i class="fas fa-share-square"></i>
                </az-submit>
                <template v-if="oc_selecionada.fl_autorizado">
                    <button type="button" class="btn btn-success ml-1" data-toggle="tooltip" title="Enviar Ordem de Compra para o Fornecedor" @click="enviar_oc_whatsapp()">
                        <i class="fas fa-share-square"></i>
                    </button>    

                    <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" @click="editar_oc_autorizada()" title="Editar Ordem de Compra">
                        <i class="fa-solid fa-pen-to-square"></i>
                    </button>    
                </template>
                <button type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" title="Programação de Entrega" @click="abrir_entregas(oc_selecionada.id_aquisicao_ordem_compra)">
                    <i class="fa-regular fa-calendar-check"></i>
                </button>    
                <slot name="voltar"></slot>
            </div>
            <div class="col col-12 col-md-8">
                <h3 class="text-right">
                    <div class="badge" :class="'badge-' + oc_selecionada.status_aprovacao.color">
                        {{ oc_selecionada.status_aprovacao.title }}
                    </div>
                </h3>
                <slot name="autorizacao"></slot>
            </div>
        </div>

        <div id="oc-print" class="mt-3">

            <p class="alert alert-warning mt-3" v-if="oc_selecionada.st_observacao_interna">
                {{ oc_selecionada.st_observacao_interna }}
            </p>

            <p class="alert mt-3" :class="oc_selecionada.fl_autorizado === false ? 'alert-danger' : 'alert-warning'" v-if="oc_selecionada.st_comentarios">
                {{ oc_selecionada.st_comentarios }}
            </p>

            <div class="alert alert-info mt-3 d-flex justify-content-between">
                <div>
                    <div class="small text-muted">Condições:</div>
                    <span v-html="oc_selecionada.detalhe_condicoes"></span>
                </div>
                <div v-if="oc_selecionada.st_tipo_prazo_entrega">
                    <div class="small text-muted">Prazo de Entrega:</div>
                    <span v-html="oc_selecionada.st_tipo_prazo_entrega"></span>
                </div>
                <div v-if="oc_selecionada.st_tipo_frete == 'FOB' && oc_selecionada.dc_valor_frete > 0">
                    <div class="small text-muted">Frete:</div>
                    {{ $util.formatMoeda(oc_selecionada.dc_valor_frete) }}
                </div>
                <div v-if="oc_selecionada.dt_validade">
                    <div class="small text-muted">Validade:</div>
                    <div>{{ $util.getFormatDate(oc_selecionada.dt_validade) }}</div>
                    <div class="small">
                        {{ $util.getHumanDuration(oc_selecionada.dt_validade) }}
                    </div>
                </div>
            </div>

            <table class="table table-sm small table-secondary" v-if="oc_selecionada.entregas && oc_selecionada.entregas.length">
                <thead>
                    <tr>
                        <th>Data de Entrega</th>
                        <th>Observações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(entrega, index) in oc_selecionada.entregas" :key="index">
                        <td>{{ $util.getFormatDate(entrega.dt_entrega) }}</td>
                        <td>{{ entrega.st_observacoes }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="alert alert-info mt-3" v-if="oc_selecionada.st_observacao_externa">
                Obs.: <span style="white-space: pre-wrap;">{{ oc_selecionada.st_observacao_externa }}</span>
            </div>

            <div class="mb-1" v-if="oc_selecionada.fl_endereco_entrega && oc_selecionada.st_endereco_entrega">
                <div class="small text-muted">Endereço de Entrega:</div>
                <div class="small" style="white-space: pre-wrap;">{{ oc_selecionada.st_endereco_entrega }}</div>
            </div>
            
            <div class="table-responsive-md">
                <table class="table cabecalho-fixo-modal">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th class="text-right">Preço</th>
                            <th class="text-right">Qtd</th>
                            <th class="text-right" v-if="exibicao_receb">Receb</th>
                            <th class="text-right">Total</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(oci, iox) in oc_selecionada.items" :key="iox">
                            <td>{{ oci.preco.item.search }}
                                <span class="badge badge-secondary">
                                    #{{ oci.preco.item.id_estoque_item }}
                                </span>
                                <span class="text-muted" v-if="oci.preco.st_observacao">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ oci.preco.st_observacao }}
                                </span>

                                <div class="mt-2" v-if="oci.preco.solic_items && oci.preco.solic_items.length">
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between py-1" v-for="(esi, isx) in oci.preco.solic_items" :key="isx">
                                            <div>Solic: {{ esi.id_estoque_solicitacao }}
                                                <span v-if="esi.solicitacao && esi.solicitacao.marcacao">
                                                    <template v-if="esi.solicitacao.marcacao.id_atendimento">| #{{ esi.solicitacao.marcacao.id_atendimento }}</template>
                                                    <template v-else-if="esi.solicitacao.marcacao.id_marcacao">| M{{ esi.solicitacao.marcacao.id_marcacao }}</template>
                                                </span>
                                            </div>
                                            <div>{{ esi.in_quantidade }}
                                                <i class="fa fa-plus-circle text-success fa-fw ml-2" aria-hidden="true" v-if="!esi.solicitacao.fl_estorno"></i>
                                                <i class="fa fa-minus-circle text-danger fa-fw ml-2" aria-hidden="true" v-else></i>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td class="text-right">
                                {{ $util.formatMoeda(oci.preco.dc_preco, 6, 2) }}
                                <div class="small text-muted" v-if="oci.preco.dc_ipi > 0">
                                    IPI: {{ $util.formatMoeda(oci.preco.dc_ipi) }}
                                </div>
                            </td>
                            <td class="text-right">{{ Math.round(oci.preco.dc_quantidade) }}
                                <div class="small text-muted">{{ oci.preco.item.st_unidade }}</div>
                            </td>
                            <td class="text-right" v-if="exibicao_receb">
                                <a href="#" @click.prevent="oci.updated_at = !oci.updated_at">
                                    {{ oci.nf_items.reduce((total, carry) => { 
                                            return total + parseInt(carry.dc_quantidade);
                                        }, 0)
                                    }}
                                </a>
                                <div v-if="!oci.updated_at">
                                    <div v-for="(nf, inx) in oci.nf_items" :key="inx" class="small text-muted text-right">
                                        NF #{{ nf.id_estoque_nota_fiscal }} / QT: {{ nf.dc_quantidade }}
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">{{ $util.formatMoeda((parseFloat(oci.preco.dc_preco) + parseFloat(oci.preco.dc_ipi)) * parseFloat(oci.preco.dc_quantidade)) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <!-- oc_selecionada.status_aprovacao.color -->
                            <th :colspan="exibicao_receb ? 4 : 3">Total</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar_lista_precos(oc_selecionada.items.map(loci => loci.preco))) }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="telefoneModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar para o Fornecedor</h5>
                        <button type="button" class="close" @click="fechar_modal('telefoneModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="fone"
                            v-model="oc_selecionada.fornecedor.st_telefone">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-whatsapp fa-fw" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </template>
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <a :href="whatsapp_link" target="_blank" 
                                        :disabled="!oc_selecionada.fornecedor.st_telefone"
                                        class="btn btn-success">Enviar</a>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            type="email"
                            v-model="oc_selecionada.fornecedor.st_email1">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="far fa-envelope-open fa-fw"></i>
                                    </span>
                                </div>
                            </template>
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <az-submit :disabled="!oc_selecionada.fornecedor.st_email1" @click="enviar_oc_fornecedor()">Enviar</az-submit>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal('telefoneModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <o-c-entregas ref="entregas" @refresh="refresh_entregas" />
    </div>
</template>

<script>
//import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
//import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import OCEntregas from './OCEntregas.vue';

export default {
    data() { 
        return { 
            validate: false, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit,
        OCEntregas, 
    },

    props: ['oc_selecionada', 'modal'],

    computed: { 
        whatsapp_link() {
            let nl = "\n"; // "%0D%0A";
            let msg = "";
            let celular = "";

            msg = msg + this.oc_selecionada.fornecedor.search;
            celular = this.oc_selecionada.fornecedor.st_telefone;
            
            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = "55" + celular;

            msg = msg + nl;

            msg = msg + "Segue Ordem de Compra #" + this.oc_selecionada.id_aquisicao_ordem_compra + nl;
            msg = msg + this.oc_selecionada.link; 

            return "https://wa.me/" + celular + "?text=" + encodeURIComponent(msg);
        },

        exibicao_receb() { 
            return this.oc_selecionada && this.oc_selecionada.status_aprovacao.color == 'success'
                && this.oc_selecionada.items.find(item => item.nf_items);
        },
    },

    methods: { 
        editar_oc_autorizada () { 
            if ( !confirm('Confirma editar a Ordem de Compra?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'cancelar_autorizar_oc', 
                dados: { 
                    id_aquisicao_ordem_compra: this.oc_selecionada.id_aquisicao_ordem_compra, 
                },
                modal: this.modal, 
                callback: () => { 
                    this.$router.push({ path: '/suprimentos/aquisicao/' + this.oc_selecionada.id_aquisicao });
                },
            });
        },

        refresh_entregas () { 
            $('.modal').modal('hide');
            this.$emit('refresh'); 
        },
        
        abrir_entregas(id) { 
            this.$refs.entregas.abrir(id);
        }, 

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },

        enviar_oc_fornecedor() { 
            if ( !confirm('Confirma enviar a OC para o fornecedor por e-mail?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'enviar_oc_fornecedor',
                dados: { 
                    id_aquisicao_ordem_compra: this.oc_selecionada.id_aquisicao_ordem_compra,
                    email: this.oc_selecionada.fornecedor.st_email1.split(';'), 
                },
                callback: res => { 
                    if ( res.length ) { 
                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "OC enviada para: " + res.join(','),
                            life: 3000
                        });
                    }
                },
            });
        },

        enviar_oc_whatsapp() { 
            $('#telefoneModal').modal('show');
        },

        imprimir_oc() { 
            this.$util.print_preview('imprimir/oc/' + this.oc_selecionada.id_aquisicao_ordem_compra, true);
        },

        remover_oc() { 
            if ( !confirm('Confirma remover a ordem de compra?') )
                return;

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'remover_oc',
                dados: { 
                    id: this.oc_selecionada.id_aquisicao_ordem_compra,
                },
                modal: this.modal, 
                callback: () => { 
                    this.$emit('refresh');
                } 
            });
        },

        enviar_oc_para_autorizacao() { 
            if ( !confirm('Confirma enviar OC para autorização por e-mail para os autorizantes?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'enviar_oc_autorizacao',
                dados: { 
                    id_aquisicao_ordem_compra: this.oc_selecionada.id_aquisicao_ordem_compra,
                },
                callback: res => { 
                    if ( res.length ) { 
                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "OC enviada para: " + res.join(','),
                            life: 3000
                        });
                    }
                }
            });
        },

        totalizar_lista_precos (precos) { 
            return precos.reduce((total, carry) => total + ( ( parseFloat(carry.dc_preco) + parseFloat(carry.dc_ipi) ) * parseFloat(carry.dc_quantidade) ), 0);
        },
    }

}
</script>